import React from 'react'
import {Box, Skeleton} from "@mui/material";

const ExpandlessPlaceholder = () => {

    return <Box sx={{width:{ xs : '100%',md : '100%',lg : '100%'}, marginBottom:'23px'}}>
        <Skeleton sx={{width:{ xs : '100%',md : '100%',lg : '100%'}}} height={48}/>
        <Skeleton sx={{width:{ xs : '100%',md : '100%',lg : '100%'}}} height={208}/>
    </Box>
}

export default ExpandlessPlaceholder
